import React, { Fragment, Component } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
    Grid,
    FormControl,
    Button,
    RadioGroup,
    Radio,
    FormLabel,
    FormControlLabel,
} from '@material-ui/core';
import InfoTooltip from '../../InfoTooltip';

import { Translate } from '../../Localization/Translate';
// import Api from '../../../nibeApi';

class SelectPump extends Component {
    constructor(props) {
        super(props);
        this.state = {
            componentLoaded: false,
            emailCheckValue: '',
            classes: '',
            goNextIsActive: false,
            selectedPumpTypeLocal: '',
            selectedPumpLocal: '',
            visiblePumps: [],
            pumptypes: [],
        };
    }

    componentDidMount() {
        // Get Pumps (We now do this on initial form load)
        //this.getPumps();

        const { pump, pumpType, pumptypes } = this.props;
        if (pumptypes) {
            let visiblePumps = pumptypes[0].pumpSeries;
            if (pumpType) {
                const foundPumps = pumptypes.filter(x => x.type === pumpType);
                if (foundPumps.length > 0) {
                    visiblePumps = foundPumps[0].pumpSeries;
                }
            }

            this.setState({
                pumptypes,
                visiblePumps,
                selectedPumpLocal: pump,
                selectedPumpTypeLocal: pumpType || pumptypes[0].type,
                goNextIsActive: pump && pumpType
            }, () => {
                if (visiblePumps.length === 1) {
                    this.updatePumpSelection(null, visiblePumps[0]);
                }
            });
        }

        this.setState({
            componentLoaded: true
        });

    }

    togglePumps(type) {
        let pumptypes = [...this.state.pumptypes];
        let selectedPumps = pumptypes.filter(x => x.type === type);
            if (selectedPumps.length > 0) {
            const visiblePumps = selectedPumps[0].pumpSeries;

            if (visiblePumps.length === 1) {
                this.setState({
                    visiblePumps,
                    selectedPumpTypeLocal: type,
                    goNextIsActive: true
                }, () => this.updatePumpSelection(null, visiblePumps[0]));
            } else {
                this.props.updateState("pump", '');
                this.props.updateState("selectedPumpObject", null);
                this.props.updateState("pumpType", type);
                this.setState({
                    visiblePumps,
                    selectedPumpTypeLocal: type,
                    selectedPumpLocal: '',
                    goNextIsActive: false
                });
            }
        }
    }

    updatePumpSelection(event, pump) {
        let type = this.state.selectedPumpTypeLocal;
        let pumptypes = [...this.state.pumptypes];
        const updateType = pumptypes.filter(x => x.type === type);
        let goNextIsActive = false;
        if (updateType) {
            updateType[0].selectedValue = pump.series;
            goNextIsActive = true;
            const selectedPump = pump;
            this.props.updateState("pump", selectedPump.series);
            this.props.updateState("pumpType", type);
            this.props.updateState("selectedPumpObject", pump);

            this.setState({
                pumptypes,
                goNextIsActive,
                selectedPumpLocal: selectedPump.series
            });
        }
    }

    handleBack = () => {
        const { updateState, activeStep } = this.props;
        if (updateState) {
            updateState("activeStep", activeStep - 1);
        }
    };

    render() {
        const classes = makeStyles(() => ({
            root: {
                width: '100%',
            },
        }));

        const { updateSteps } = this.props;
        const { componentLoaded, pumptypes, visiblePumps, goNextIsActive, selectedPumpLocal, selectedPumpTypeLocal } = this.state;

        return (
            <div>
                {!componentLoaded ? (<div>LOADING</div>) : (
                    <Fragment>
                        <form className={classes.root} noValidate autoComplete="off" onSubmit={(e) => e.preventDefault()}>
                            <FormControl component="fieldset" className={classes.formControl}>
                                <Grid container alignItems="flex-start" spacing={2}>
                                    <Grid item xs={12}>
                                        <RadioGroup
                                            aria-label={Translate('QuoteTool/step2/pumptypelabel')}
                                            name={Translate('QuoteTool/step2/pumptypelabel')}
                                            className={classes.group}
                                            value={this.state.value}
                                            onChange={this.handleChange}
                                        >
                                            <Grid container alignItems="flex-start" spacing={2} className='pump-grid__wrap'>
                                                <Grid item xs={12} sm={12} className='pump__header'>
                                                    <FormLabel component="legend">{Translate('QuoteTool/step2/pumptypelabel')}</FormLabel>
                                                </Grid>
                                                <Grid item xs={12} sm={12} container alignItems="flex-start" spacing={2}>
                                                    {pumptypes && pumptypes.map((pumpTypeItem, i) => {
                                                        return (
                                                            <div className='pump-item' key={i}>
                                                                <FormControlLabel
                                                                    value={pumpTypeItem.type}
                                                                    control={<Radio color="primary" />}
                                                                    label={Translate('QuoteTool/step2/' + pumpTypeItem.type + 'label')}
                                                                    labelPlacement="end"
                                                                    onChange={() => this.togglePumps(pumpTypeItem.type)}
                                                                    checked={(selectedPumpTypeLocal && selectedPumpTypeLocal === pumpTypeItem.type) || (!selectedPumpTypeLocal && i === 0)}
                                                                />
                                                            </div>
                                                        )
                                                    })}
                                                </Grid>
                                            </Grid>
                                        </RadioGroup>
                                        <RadioGroup
                                            aria-label={Translate('QuoteTool/step2/pumplabel')}
                                            name={Translate('QuoteTool/step2/pumplabel')}
                                            className={classes.group}
                                            value={this.state.value}
                                            onChange={this.handleChange}
                                        >
                                            <Grid container alignItems="flex-start" spacing={2} className='pump-grid__wrap' >
                                                <Grid item xs={12} sm={12} className='pump__header'>
                                                    <FormLabel component="legend">{Translate('QuoteTool/step2/pumplabel')}</FormLabel>
                                                </Grid>
                                                <Grid item xs={12} sm={12} container alignItems="flex-start" spacing={2}>
                                                    {visiblePumps && visiblePumps.map((pump, i2) => {
                                                        return (
                                                            <div className='pump-item' key={i2}>
                                                                <FormControlLabel
                                                                    value={pump.series}
                                                                    control={<Radio color="primary" />}
                                                                    label={pump.series}
                                                                    labelPlacement="end"
                                                                    onChange={(e) => this.updatePumpSelection(e, pump)}
                                                                    checked={visiblePumps.length === 1 ? true : false || selectedPumpLocal === pump.series}
                                                                    className='pump-grid__label'
                                                                />
                                                                <InfoTooltip label={Translate("QuoteTool/general/pumpinfo/" + pump.series) === 'QuoteTool/general/pumpinfo/' + pump.series
                                                                    ? null : Translate("QuoteTool/general/pumpinfo/" + pump.series)} />
                                                            </div>
                                                        )
                                                    })}
                                                </Grid>
                                            </Grid>
                                        </RadioGroup>
                                    </Grid>
                                </Grid>
                            </FormControl>
                        </form>

                        <Grid container alignItems="flex-start" spacing={2}>
                            <Grid item xs={12} sm={12} md={6}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={this.handleBack}
                                    className={classes.button}
                                >
                                    {Translate("QuoteTool/general/buttonback")}
                                </Button>&nbsp;

                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() => updateSteps(2, 2)}
                                    className={classes.button}
                                    disabled={!goNextIsActive}
                                >
                                    {Translate("QuoteTool/general/buttonnext")}
                                </Button>
                            </Grid>
                        </Grid>


                    </Fragment>
                )}
            </div>
        );
    }
}

export default SelectPump;